import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import Layout from './Layout';
import { addUserSpecificDomains } from '../../../library/Service/domainService';

const InternalAdminReport = () => {
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

    useEffect(() => {
        // const domain = new Map([...globalState.domain]);
        const userStatusCodes = domain.get('USER_STATUS_CODE');
        if (userStatusCodes) {
            const filtereduserstatusCode = userStatusCodes.filter((status) => status.code !== 'PENDING_EMAIL_VERIFICATION');
            domain.set('USER_STATUS_CODE', filtereduserstatusCode);
        }
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, internal, routeInfo },
        });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && <Layout />}
        </SmartContext.Provider>
    );
};

export default InternalAdminReport;
